export default __webpack_public_path__ + "static/media/black1.148156b6.png";